import { render } from "./CustomPageBuilder.vue?vue&type=template&id=079e0936&scoped=true"
const script = {}

import "./CustomPageBuilder.vue?vue&type=style&index=0&id=079e0936&lang=scss&scoped=true"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079e0936"]])

export default __exports__